import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { Scores, SetOfAssessments } from 'src/modules/assessments/components/SetOfAssessments';
import { FlowType } from 'src/modules/assessments/models/assessments';
import { getMostRecentCareRecommendation } from 'src/modules/user/selectors/userSelectors';
import { useOnboardingGuard } from 'src/shared/hooks/useOnboardingGuard';

import { BrandWrapper } from '../components/BrandWrapper';

export const OnboardingSurveyStepPage: React.FC<RouteComponentProps> = ({ history }) => {
    const shouldRender = useOnboardingGuard();
    const careRecommendationUuid = useSelector(getMostRecentCareRecommendation)?.uuid || undefined;

    const handleAssessmentsSubmit = (_scores: Scores) => {
        history.push('/pick-your-type-of-care');
    };

    if (!shouldRender) {
        return null;
    }

    return (
        <BrandWrapper>
            <SetOfAssessments
                onSubmit={handleAssessmentsSubmit}
                flowType={FlowType.INITIAL_ONBOARDING}
                startAssessmentFlowVariables={{ careRecommendationUuid }}
            />
        </BrandWrapper>
    );
};
